module.exports = __webpack_public_path__ + "static/media/in.bc7dabdf.svg";